/** Action Plan v2 — route/module tách biệt /du-an, không dùng chung session key. */

import { formatDateRangeForUrl } from './core/date';

export const ACTION_PLAN_V2 = {
  ROUTE_BASE: '/action-plan',
  ROUTE_HOME: '/action-plan-v2',
  ROUTE_BAO_CAO: '/action-plan/bao-cao',
  ROUTE_CONG_VIEC: '/action-plan/cong-viec',
  ROUTE_MUC_TIEU: '/action-plan-v2/muc-tieu',
  /** Tổng quan APV2 — trang riêng (không dùng query `from`). */
  ROUTE_TONG_QUAN_CONG_VIEC: '/tong-quan-cong-viec-v2',
  SESSION_KEY: 'action-plan-v2-session',
  PHAN_HE: 'bsc' as const,
  TAB: {
    PHU_TRACH: 'pt',
    HO_TRO: 'ht',
    DA_GIAO: 'dg',
    DUOC_GIAO: 'dcg',
  },
  HIEN_THI_VIEC_CUA_TOI: '1',
  /** Tổng quan toàn cây — export / HienThi BE (không gắn UI kiểu trình bày). */
  HIEN_THI_TONG_QUAN_TOAN_CAY: '2',
  /** Tổng quan việc của tôi — neo + descendants (overview APV2). */
  HIEN_THI_TONG_QUAN_VIEC_CUA_TOI: '3',
} as const;

/** V2 workspace luôn chế độ cây (không flat; không đọc/ghi query `kieuTrinhBay`). */
export const APV2_TREE_DISPLAY = '2';

/**
 * Link tổng quan công việc APV2 → `/tong-quan-cong-viec-v2`.
 * `dateChoice`: chuỗi hiển thị `DD/MM/YYYY - DD/MM/YYYY`.
 */
export function buildTongQuanCongViecHref(dateChoice?: string | null): string {
  const path = `${ACTION_PLAN_V2.ROUTE_TONG_QUAN_CONG_VIEC}/`;
  const q = new URLSearchParams();
  const compact = formatDateRangeForUrl(dateChoice || null);
  if (compact && compact !== 'nulldate') {
    q.set('dateChoice', compact);
  }
  const qs = q.toString();
  return qs ? `${path}?${qs}` : path;
}

/** Nút quay về trên tổng quan APV2 → home Action Plan V2. */
export function resolveTongQuanV2BackTarget(): {
  href: string;
  tooltipKey: string;
  tooltipFallback: string;
} {
  return {
    href: ACTION_PLAN_V2.ROUTE_HOME,
    tooltipKey: 'bsc.btn.vequanlyactionplan',
    tooltipFallback: 'Về Quản lý Action Plan',
  };
}

/** @deprecated Legacy V1 back — luôn về /du-an. */
export function resolveTongQuanBackTarget(_from?: unknown): {
  href: string;
  tooltipKey: string;
  tooltipFallback: string;
} {
  return {
    href: '/du-an',
    tooltipKey: 'bsc.btn.veduan',
    tooltipFallback: 'Về dự án',
  };
}

/** Vào trang V2 khi công ty bật «Sử dụng Action Plan V2» (Thiết lập › Cấu hình) — `useActionPlanV2Enabled`. */
export function canAccessActionPlanV2(actionPlanV2Enabled: boolean): boolean {
  return actionPlanV2Enabled;
}

/** Trợ lý BSC (AI) chỉ bật cho tài khoản đăng nhập bắt đầu bằng một trong các email này (gồm biến thể `_demo`). */
export const ACTION_PLAN_V2_AI_ASSISTANT_EMAIL_PREFIXES = [
  'namht@toppion.com.vn',
  'namht_demo@toppion.com.vn',
] as const;

export function canUseActionPlanV2AiAssistant(email?: string | null): boolean {
  const normalized = (email ?? '').trim().toLowerCase();
  return ACTION_PLAN_V2_AI_ASSISTANT_EMAIL_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}

/** Menu chỉ hiện một bản: bật «Sử dụng Action Plan V2» → menu V2, tắt (mặc định) → menu bản cũ `/du-an`. */
export function canShowActionPlanV2Menu(actionPlanV2Enabled: boolean): boolean {
  return actionPlanV2Enabled;
}
